import { Search } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';

export type RiskFilter = 'all' | 'low' | 'medium' | 'high';

interface TradingFiltersProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  searchPlaceholder?: string;
  riskFilter?: RiskFilter;
  onRiskFilterChange?: (value: RiskFilter) => void;
  showRiskFilters?: boolean;
}

const TradingFilters = ({
  searchTerm,
  onSearchChange,
  searchPlaceholder = 'Search...',
  riskFilter = 'all',
  onRiskFilterChange,
  showRiskFilters = true,
}: TradingFiltersProps) => {
  const riskOptions: { label: string; value: RiskFilter }[] = [
    { label: 'All Risks', value: 'all' },
    { label: 'Low Risk', value: 'low' },
    { label: 'Medium Risk', value: 'medium' },
    { label: 'High Risk', value: 'high' },
  ];

  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
      <div className="relative flex-1 max-w-md">
        <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <Input
          type="text"
          placeholder={searchPlaceholder}
          value={searchTerm}
          onChange={e => onSearchChange(e.target.value)}
          className="pl-10"
        />
      </div>

      {showRiskFilters && onRiskFilterChange && (
        <div className="flex flex-wrap items-center gap-2">
          {riskOptions.map(option => (
            <Button
              key={option.value}
              variant={riskFilter === option.value ? 'default' : 'outline'}
              size="sm"
              onClick={() => onRiskFilterChange(option.value)}
            >
              {option.label}
            </Button>
          ))}
        </div>
      )}
    </div>
  );
};

export default TradingFilters;
